class VideoPlayer {
  constructor(videoSelector, buttonSelector) {
    this.videoWrappers = Array.from(document.querySelectorAll(videoSelector)); 
    this.videos = [];
    this.hideTimeouts = {};
    this.buttonSelector = buttonSelector; 
    if (this.videoWrappers.length > 0) {
      this.init();
    }
  }

  init() {
    this.videoWrappers.forEach((wrapper, index) => {
      const video = wrapper.querySelector("video");
      const button = wrapper.querySelector(this.buttonSelector);
      
      if (video && button) {
        this.videos[index] = video;

        wrapper.addEventListener("click", () => this.togglePlay(index));

        button.addEventListener("click", (event) => {
          event.stopPropagation();
          this.togglePlay(index);
        });
      }
    });
  }

  togglePlay(index) {
    const video = this.videos[index];
    const wrapper = this.videoWrappers[index];
    const button = wrapper.querySelector(this.buttonSelector);

    if (!video) return;

    if (video.paused) {
      const posterEl = wrapper.querySelector(".video_poster");
      if (posterEl) posterEl.remove();

      video.play().catch(console.error);

      button.textContent = "⏸";
      button.classList.remove("paused");
      button.classList.add("playing");

      clearTimeout(this.hideTimeouts[index]);
      this.hideTimeouts[index] = setTimeout(() => {
        button.style.opacity = "0";
      }, 500);

    } else {
      video.pause();
      button.textContent = "▶";
      button.classList.remove("playing");
      button.classList.add("paused");
      button.style.opacity = "1";
      clearTimeout(this.hideTimeouts[index]);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new VideoPlayer(".video-class", ".playBtn");
});
